import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EmployeesContainer } from 'src/features/employees/containers/employees';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/tenant/employees/_layout/')({
  component: EmployeesContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
